import { Badge } from '@cowbell/ui';
import type { EntityProfileAction } from '../../types';
import styles from './ActionCard.module.css';

interface Props {
  action: EntityProfileAction;
}

export default function EntityProfileCard({ action }: Props) {
  if (action.entityType === 'threat-actor' && action.actor) {
    const { actor } = action;
    return (
      <div className={styles.card}>
        <div className={styles.entityProfile}>
          <div className={styles.entityProfileName}>
            {actor.name}
            <Badge size="xs" color="red" ml="xs">
              {actor.primaryMotivation}
            </Badge>
          </div>
          {actor.aliases.length > 0 && (
            <div className={styles.entityProfileAliases}>
              aka {actor.aliases.join(', ')}
            </div>
          )}
        </div>

        <div className={styles.entityProfileDetail}>
          <span>MITRE ID</span>
          <span>{actor.mitreId}</span>
        </div>
        <div className={styles.entityProfileDetail}>
          <span>Resource Level</span>
          <span>{actor.resourceLevel}</span>
        </div>
        <div className={styles.entityProfileDetail}>
          <span>Techniques</span>
          <span>{actor.techniqueCount}</span>
        </div>
        <div className={styles.entityProfileDetail}>
          <span>First Seen</span>
          <span>{actor.firstSeen}</span>
        </div>
        <div className={styles.entityProfileDetail}>
          <span>Last Seen</span>
          <span>{actor.lastSeen}</span>
        </div>

        {actor.associatedTechniques.length > 0 && (
          <div style={{ marginTop: '8px' }}>
            <div className={styles.cardSubtitle}>Key Techniques</div>
            {actor.associatedTechniques.slice(0, 5).map((t) => (
              <div key={t.tid} className={styles.entityProfileDetail}>
                <span>{t.tid}</span>
                <span>{t.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Generic entity profile card
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>{action.entityType} Profile</div>
      <div className={styles.cardSubtitle}>
        Entity profile details are loading...
      </div>
    </div>
  );
}
